const LoadMoreBlock = function(selector, opts) {
	const module = {
		opts: {
			$el: $(selector),
			loadMoreSelector: '[data-load-more]',
			showAllSelector: '[data-show-all]',
			cardSelector: '.block',
			chunkSize: $(window).width() >= 992 ? opts.chunkSize.desktop : opts.chunkSize.mobile,
		},
		bindEvents: function() {
			$(this.opts.loadMoreSelector).on('click', this.loadMore.bind(this));
			$(this.opts.showAllSelector).on('click', this.showAllRemaining.bind(this));
		},
		init: function() {
			this.opts.$el.each(this.setupCards.bind(this));
			this.bindEvents();
		},
		setupCards: function(i, el) {
			const $section = $(el);
			const $cards = $section.find(this.opts.cardSelector);
			const chunkSize = this.opts.chunkSize === -1 ? $cards.length : this.opts.chunkSize;
			const data = {
				chunks: [],
				currentChunk: 0,
				total: $cards.length,
			};

			// Loop through and chunk cards into an array we can paginate over
			for (let i = 0; i < $cards.length; i += chunkSize) {
				data.chunks.push($cards.slice(i, i + chunkSize));
			}

			// Store data on the jQuery object
			$section.data('loadMoreData', data);

			// Check if we should hide the load more button
			if (data.chunks.length > 0 && data.total <= chunkSize) {
				$section.find(this.opts.loadMoreSelector).hide();
				$section.find(this.opts.showAllSelector).hide();
			}

			$cards.hide();

			this.loadMore($section);
		},
		loadMore: function($el) {
			let { chunks, currentChunk } = $el.data('loadMoreData');
			chunks[currentChunk].show();
			currentChunk++;

			if (currentChunk === chunks.length) {
				$(this.opts.loadMoreSelector).hide();
			}
		},
		showAllRemaining: function(e) {
			const $section = $(e.currentTarget).parents().filter(this.opts.$el);
			$section.find(`${this.opts.cardSelector}:not(:visible)`).show();
			$section.find(this.opts.showAllSelector).hide();
			$section.trigger('trmk.loadMoreBlock.showAll');
		},
	}

	if (module.opts.$el.length) {
		module.init();
	}

	return module;
}

/**
 * Block Load More Grid
 */
const loadMoreGrid = new LoadMoreBlock('.block-load-more-grid', {
	chunkSize: {
		desktop: -1,
		mobile: 3,
	}
});
